// extracted by mini-css-extract-plugin
export default {"wrapper":"ProductsHeader_wrapper__AJZKK"};